
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";


export default function BaoCaoXePhongHop() {
    const { user } = useSelector((state) => state.auth);
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        const fetchAndProcessData = async () => {
            try {
                // chạy song song
                const [carRes, roomRes] = await Promise.all([
                    Axios.get(URL_LIST_ALL + "car_booking?baocao=1&limit=100000", user.config),
                    Axios.get(URL_LIST_ALL + "room_booking?baocao=1&limit=100000", user.config),
                ]);

                // kiểm tra status
                if (carRes.data.status !== "success" || roomRes.data.status !== "success") {
                    console.error(
                        carRes.data.message || roomRes.data.message || "Lỗi tải dữ liệu"
                    );
                    return;
                }

                // lấy data
                const carData = carRes.data.data || [];
                const roomData = roomRes.data.data || [];

                // xử lý tổng hợp tháng
                const reportData = processDataByMonth(carData, roomData);
                setChartData(reportData); // giả sử bạn có state chartData
            } catch (error) {
                console.error("Lỗi gọi API:", error);
            }
        };

        fetchAndProcessData();
    }, [user]);

    const processDataByMonth = (carData, roomData) => {
        const data = Array.from({ length: 12 }, (_, index) => ({
            month: index + 1,
            carBookingCount: 0,
            roomBookingCount: 0,
        }));

        carData.forEach((item) => {
            const d = new Date(item.datestart_picker.replace(' ', 'T'));
            const m = d.getMonth();
            data[m].carBookingCount += 1;
        });

        roomData.forEach((item) => {
            const d = new Date(item.datestart_picker.replace(' ', 'T'));
            const m = d.getMonth();
            data[m].roomBookingCount += 1;
        });

        return data;
    }

    return (<AkkhorLayout idrole="bao-cao-xe-phong-hop">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Báo cáo
                </li>
            </ul>
        </div>

        <div className="w-100 main-baocao">
            <div className="d-none d-sm-block">
                <ResponsiveContainer width="100%" height={500}>
                    <BarChart data={chartData}>
                        <defs>
                            <linearGradient id="colorCar" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#183861" stopOpacity={1} />
                                <stop offset="100%" stopColor="#08B1C0" stopOpacity={1} />
                            </linearGradient>
                            <linearGradient id="colorRoom" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#0065A2" stopOpacity={1} />
                                <stop offset="100%" stopColor="#00A5E3" stopOpacity={1} />
                            </linearGradient>
                        </defs>

                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" tickFormatter={(m) => `Tháng ${m}`} />
                        <YAxis domain={[0, (dataMax) => Math.ceil(dataMax * 1.1)]}  />
                        <Tooltip formatter={(value) => `${value} lượt`} />
                        <Legend />

                        <Bar dataKey="carBookingCount" fill="url(#colorCar)" name="Đặt Xe" label={{ position: "top" }} />
                        <Bar dataKey="roomBookingCount" fill="url(#colorRoom)" name="Đặt Phòng Họp" label={{ position: "top" }} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
            <div className="d-block d-sm-none">
                <ResponsiveContainer width="100%" height={1000}>
                    <BarChart data={chartData} layout="vertical" margin={{ left: 0, right: 20 }}>
                        <defs>
                            <linearGradient id="colorCar" x1="0" y1="0" x2="1" y2="0">
                                <stop offset="0%" stopColor="#183861" />
                                <stop offset="100%" stopColor="#08B1C0" />
                            </linearGradient>
                            <linearGradient id="colorRoom" x1="0" y1="0" x2="1" y2="0">
                                <stop offset="0%" stopColor="#ffa901" />
                                <stop offset="100%" stopColor="#b47700" />
                            </linearGradient>
                        </defs>

                        {/* Với layout ngang thì X trở thành trục số, Y trở thành danh mục */}
                        <XAxis type="number" />
                        <YAxis dataKey="month" type="category" tickFormatter={(m) => `T${m}`} width={60} />

                        <Tooltip formatter={(val) => `${val} lượt`} />
                        <Legend />

                        <Bar dataKey="carBookingCount" fill="url(#colorCar)" label={{ position: "right", fill: "#333" }} name="Đặt Xe" />
                        <Bar dataKey="roomBookingCount" fill="url(#colorRoom)" label={{ position: "right", fill: "#333" }} name="Đặt Phòng" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    </AkkhorLayout>);
}
